import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { useTranslatedChildren } from '../../../hooks/useTranslatedChildren'
import { isNewStylesThemeEnabledSelector } from '../../../modules/selectors/app'

import Radio from '../Radio'

import useStyles from './styles'
import * as classes from './styles.css'

function RadioButton(props) {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)
  const legacyClasses = useStyles()

  const vanillaClasses = {
    radioButton: classes.radioButton
  }
  const activeClasses = isNewStylesThemeEnabled ? vanillaClasses : legacyClasses

  const { name = '', value = '', label = '', subText = '', setFieldValue, selectedValue = '', ...restProps } = props

  const checked = selectedValue === value

  const translatedLabel = useTranslatedChildren(label)

  const handleOnChange = useCallback(() => {
    setFieldValue(name, value)
  }, [setFieldValue, name, value])

  return (
    <Radio
      name={name}
      value={value}
      checked={checked}
      onChange={handleOnChange}
      label={translatedLabel}
      subText={subText}
      titleClassName={activeClasses.radioButton}
      {...restProps}
    />
  )
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  selectedValue: PropTypes.string,
  setFieldValue: PropTypes.func
}

export default RadioButton
